import React from 'react';

export const BoardReadOnlyContext = React.createContext(null);

export const useBoardReadOnlyMode = () => React.useContext(BoardReadOnlyContext);
